import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  total: {
    id: 'CompetitionDetails.LineupStats.Total',
    defaultMessage: 'Total',
  },
  totalLong: {
    id: 'CompetitionDetails.LineupStats.Total.long',
    defaultMessage: 'Total score',
  },
  bonusShort: {
    id: 'CompetitionDetails.LineupStats.Bonus.short',
    defaultMessage: '+%',
  },
  bonusLong: {
    id: 'CompetitionDetails.LineupStats.Bonus.long',
    defaultMessage: 'Bonus points',
  },
  actualGameStat: {
    id: 'CompetitionDetails.LineupStats.ActualGameStat',
    defaultMessage: 'Actual: {gameStat}',
  },
  fantasyGameScore: {
    id: 'CompetitionDetails.LineupStats.FantasyGameScore',
    defaultMessage: 'Fantasy: {gameStat}',
  },
  noGames: {
    id: 'CompetitionDetails.LineupStats.NoGames',
    defaultMessage: 'No games',
  },
});
